import React from "react";
import { Grid, Typography } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { PhotoConsumer, PhotoProvider } from "react-photo-view";
import {
  MIME_TYPE_TO_CATEGORY_MAP,
  SUPPORTED_FILE_TYPE_CATEGORIES,
} from "../../../../static-data";

const ContentView = ({
  children,
  handleRemoveFile,
  uploadedFile,
  previewUrl,
}) => {
  return (
    <Grid container direction="column" className="content-wrapper">
      {children}
      <Typography
        className="file-name"
        variant="caption"
        onClick={() => window.open(previewUrl, "_blank")}
      >
        {uploadedFile.name}
      </Typography>
      <Grid item container justifyContent="center">
        <DeleteIcon onClick={handleRemoveFile} className="delete-icon" />
      </Grid>
    </Grid>
  );
};
const ImagePreview = ({ previewUrl }) => {
  return (
    <PhotoProvider>
      <PhotoConsumer src={previewUrl}>
        <img src={previewUrl} className="uploaded-image" alt="uploaded-slip" />
      </PhotoConsumer>
    </PhotoProvider>
  );
};

const FilePreview = ({ uploadedFile, previewUrl, handleRemoveFile }) => {
  if (!uploadedFile || typeof uploadedFile.type !== "string" || !previewUrl) {
    return null;
  }

  const fileCategory = MIME_TYPE_TO_CATEGORY_MAP[uploadedFile.type];

  switch (fileCategory) {
    case SUPPORTED_FILE_TYPE_CATEGORIES.IMAGE:
      return (
        <ContentView
          handleRemoveFile={handleRemoveFile}
          uploadedFile={uploadedFile}
          previewUrl={previewUrl}
        >
          <ImagePreview previewUrl={previewUrl} />
        </ContentView>
      );
    case SUPPORTED_FILE_TYPE_CATEGORIES.PDF:
      return (
        <ContentView
          handleRemoveFile={handleRemoveFile}
          uploadedFile={uploadedFile}
          previewUrl={previewUrl}
        >
          <embed src={previewUrl} className="uploaded-pdf" />
        </ContentView>
      );
    default:
      return null;
  }
};
export default FilePreview;
